import React from 'react';
import UPPage from '../components/UPPage';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@mui/material';

/**
 * Try Again page
 */
export const TryAgain = () => {
  const { t } = useTranslation('translation');

  return (
    <UPPage>
      <Typography component="h1" variant="h5" align="center" pb={5}>
        {t('changePasswordHeader')}
      </Typography>
      <Link href={'/auth/forgotPassword'} sx={{ cursor: 'pointer' }}>
        {t('forgotPassword')}
      </Link>
      <Link href={'/auth/changePassword'} sx={{ cursor: 'pointer' }}>
        {t('tryAgain')}
      </Link>
    </UPPage>
  );
};
